import { render, staticRenderFns } from "./lawyer_add.vue?vue&type=template&id=2a067aab&scoped=true"
import script from "./lawyer_add.vue?vue&type=script&lang=js"
export * from "./lawyer_add.vue?vue&type=script&lang=js"
import style0 from "./lawyer_add.vue?vue&type=style&index=0&id=2a067aab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a067aab",
  null
  
)

export default component.exports